// Moving between the app's own pages without a reload. The router is still
// the hand-written one in App.tsx; this only tells it the path changed.

import { useEffect, useState } from "react";
import { ownRoomPath } from "./storage";

const EVENT = "breeze:navigate";

export function navigate(path: string, opts: { replace?: boolean } = {}): void {
  if (path === window.location.pathname) return;
  if (opts.replace) window.history.replaceState(null, "", path);
  else window.history.pushState(null, "", path);
  window.scrollTo(0, 0);
  window.dispatchEvent(new Event(EVENT));
}

export function usePathname(): string {
  const [path, setPath] = useState(window.location.pathname);
  useEffect(() => {
    const update = (): void => setPath(window.location.pathname);
    window.addEventListener("popstate", update);
    window.addEventListener(EVENT, update);
    return () => {
      window.removeEventListener("popstate", update);
      window.removeEventListener(EVENT, update);
    };
  }, []);
  return path;
}

/** Back to the page before, or the account's own room when this page was
 * opened straight from a link (a recording from Seamless Calls, say). */
export function goBack(): void {
  if (window.history.length > 1) window.history.back();
  else navigate(ownRoomPath(), { replace: true });
}

/** An in-app link: a real anchor (so it opens in a new tab when asked to),
 * handled here on a plain click. */
export function linkHandler(path: string) {
  return (event: { preventDefault: () => void; metaKey: boolean; ctrlKey: boolean; shiftKey: boolean; button: number }): void => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
    event.preventDefault();
    navigate(path);
  };
}
